import { render, staticRenderFns } from "./WhatsAppInboxCreate.vue?vue&type=template&id=7259640a&scoped=true&"
import script from "./WhatsAppInboxCreate.vue?vue&type=script&lang=js&"
export * from "./WhatsAppInboxCreate.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppInboxCreate.vue?vue&type=style&index=0&id=7259640a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7259640a",
  null
  
)

export default component.exports